import { render, staticRenderFns } from "./NewFiltersModal.vue?vue&type=template&id=0ff6a77c&lang=pug&"
import script from "./NewFiltersModal.vue?vue&type=script&lang=js&"
export * from "./NewFiltersModal.vue?vue&type=script&lang=js&"
import style0 from "./NewFiltersModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports